import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Container, SimpleGrid } from "@chakra-ui/react"
import { FeaturedSection } from "../.."
import StatsItem from "./StatsItem"

export function Stats() {
  const { dataJson } = useStaticQuery(graphql`
    query {
      dataJson {
        stats {
          copy
          stat
          value
        }
      }
    }
  `)

  const { stats } = dataJson

  return (
    <FeaturedSection>
      <Container>
        <SimpleGrid columns={{ base: 1, lg: 3 }} spacing={16}>
          {stats.map((item, index) => (
            <StatsItem key={index} {...item} />
          ))}
        </SimpleGrid>
      </Container>
    </FeaturedSection>
  )
}
